export default "__VITE_ASSET__BUvld6Z7__"